
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "version": "1.1",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "width": "16px",
    "height": "13px",
    "xmlns": "http://www.w3.org/2000/svg"
  },
  "children": [
    {
      "tag": "g",
      "attrsMap": {
        "transform": "matrix(1 0 0 1 -242 -245 )"
      },
      "children": [
        {
          "tag": "path",
          "attrsMap": {
            "d": "M 15.9821428571429 3.53938829787234  C 15.9821428571429 2.76595744680851  15.1217857142857 2.08916223404255  14.1383928571429 2.08916223404255  L 6.51785714285714 2.08916223404255  L 5.41071428571429 0.445664893617022  C 5.41071428571429 0.252220744680852  5.165 0.155585106382979  4.91928571428571 0.155585106382979  L 1.84678571428571 0.155585106382979  C 0.863571428571428 0.155585106382979  0.00303571428571406 0.832380319148937  0.00303571428571406 1.60581117021277  L 0.00303571428571406 11.2738696808511  C 0.00303571428571406 12.0474734042553  0.863571428571428 12.7242686170213  1.84678571428571 12.7242686170213  L 14.1383928571429 12.7242686170213  C 15.1217857142857 12.7242686170213  15.9821428571429 12.0474734042553  15.9821428571429 11.2738696808511  L 15.9821428571429 3.53938829787234  Z M 14.7530357142857 3.54007978723404  L 14.7530357142857 11.2738696808511  C 14.7530357142857 11.5639494680851  14.5071428571429 11.7579122340426  14.1383928571429 11.7579122340426  L 1.84678571428571 11.7579122340426  C 1.47803571428571 11.7579122340426  1.23232142857143 11.5644680851064  1.23232142857143 11.2738696808511  L 1.23232142857143 1.60581117021277  C 1.23232142857143 1.31573138297872  1.47803571428571 1.12176861702128  1.84678571428571 1.12176861702128  L 4.55089285714286 1.12176861702128  L 5.65714285714286 2.76595744680851  C 5.65714285714286 2.95940159574468  5.90303571428571 3.05603723404255  6.14875 3.05603723404255  L 14.1383928571429 3.05603723404255  C 14.5071428571429 3.05603723404255  14.7530357142857 3.24948138297872  14.7530357142857 3.54007978723404  Z ",
            "fill-rule": "nonzero",
            "fill": "#444444",
            "stroke": "none",
            "transform": "matrix(1 0 0 1 242 245 )"
          }
        }
      ]
    }
  ]
})
    }
  